module.exports = __webpack_public_path__ + "static/media/faq_20240119.12e94a96.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/files/faq_20240119.pdf
// module id = 2302
// module chunks = 0